import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_SCHEDULED_FLOWS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch scheduled flows.'),
      403: i18n.t('You are not allowed to fetch scheduled flows.'),
      404: i18n.t('The scheduled flows you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the scheduled flows data.'),
      default: i18n.t('An error occurred fetching the scheduled flows data.')
    }
  },
  CREATE_SCHEDULED_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to create the schedule.'),
      403: i18n.t('You are not allowed to create the schedule.'),
      500: i18n.t('There was an error creating the schedule.'),
      default: i18n.t('An error occurred creating the schedule.')
    },
    SUCCESS: {
      200: i18n.t('Schedule created.')
    }
  },
  UPDATE_SCHEDULED_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to update the schedule.'),
      403: i18n.t('You are not allowed to update the schedule.'),
      500: i18n.t('There was an error updating the schedule.'),
      default: i18n.t('An error occurred updating the schedule.')
    },
    SUCCESS: {
      200: i18n.t('Schedule updated.')
    }
  },
  ACTIVATE_SCHEDULED_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to activate the schedule.'),
      403: i18n.t('You are not allowed to activate the schedule.'),
      500: i18n.t('There was an error activating the schedule.'),
      default: i18n.t('An error occurred activating the schedule.')
    },
    SUCCESS: {
      200: i18n.t('Schedule activated.')
    }
  },
  DEACTIVATE_SCHEDULED_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to deactivate the schedule.'),
      403: i18n.t('You are not allowed to deactivate the schedule.'),
      500: i18n.t('There was an error deactivating the schedule.'),
      default: i18n.t('An error occurred deactivating the schedule.')
    },
    SUCCESS: {
      200: i18n.t('Schedule deactivated.')
    }
  },
  DELETE_SCHEDULED_FLOW: {
    ERROR: {
      401: i18n.t('You are not authorized to delete the schedule.'),
      403: i18n.t('You are not allowed to delete the schedule.'),
      404: i18n.t('The schedule you are trying to delete does not exist.'),
      500: i18n.t('There was an error deleting the schedule.'),
      default: i18n.t('An error occurred deleting the schedule.')
    },
    SUCCESS: {
      200: i18n.t('Schedule deleted.')
    }
  },
  FETCH_SCHEDULED_FLOW_EXECUTIONS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch execution history.'),
      403: i18n.t('You are not allowed to fetch execution history.'),
      500: i18n.t('An error occurred fetching the execution history.'),
      default: i18n.t('An error occurred fetching the execution history.')
    }
  },
  TRIGGER_SCHEDULED_FLOW_EXECUTION: {
    ERROR: {
      401: i18n.t('You are not authorized to trigger the execution.'),
      403: i18n.t('You are not allowed to trigger the execution.'),
      500: i18n.t('There was an error triggering the execution.'),
      default: i18n.t('An error occurred triggering the execution.')
    },
    SUCCESS: {
      200: i18n.t('Execution triggered.')
    }
  }
};
